import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const RichTextTranslationKeys = {
  richtextBold: translationKey('richtext_bold'),
  richtextBulletList: translationKey('richtext_bullet_list'),
  richtextCode: translationKey('richtext_code'),
  richtextColorBlack: translationKey('richtext_color_black'),
  richtextColorBlue: translationKey('richtext_color_blue'),
  richtextColorDarkGreen: translationKey('richtext_color_dark_green'),
  richtextColorDarkRed: translationKey('richtext_color_dark_red'),
  richtextColorDarkYellow: translationKey('richtext_color_dark_yellow'),
  richtextColorGray: translationKey('richtext_color_gray'),
  richtextColorGreen: translationKey('richtext_color_green'),
  richtextColorOrange: translationKey('richtext_color_orange'),
  richtextColorPurple: translationKey('richtext_color_purple'),
  richtextColorRed: translationKey('richtext_color_red'),
  richtextItalic: translationKey('richtext_italic'),
  richtextLineBreak: translationKey('richtext_line_break'),
  richtextLink: translationKey('richtext_link'),
  richtextLinkPrompt: translationKey('richtext_link_prompt'),
  richtextNumberedList: translationKey('richtext_numbered_list'),
  richtextRemoveTextColor: translationKey('richtext_remove_text_color'),
  richtextStrikethrough: translationKey('richtext_strikethrough'),
  richtextTextColor: translationKey('richtext_text_color'),
  richtextTextColorBasic: translationKey('richtext_text_color_basic'),
  richtextTextColorMenu: translationKey('richtext_text_color_menu'),
  richtextTextColorMore: translationKey('richtext_text_color_more'),
  richtextTextColorRecent: translationKey('richtext_text_color_recent'),
  richtextUnderline: translationKey('richtext_underline'),
} as const satisfies Record<string, TranslationKey>;
